import { requestDealerSuccessInvoiceDownload } from 'utils/http/api/dealer/success-invoices';
import useModal from 'utils/modal/useModal';

export function useDealerFinancingDetailInvoiceInformationLogics(invoiceId: number) {
  const modal = useModal();

  // invoice file 다운로드 호출
  const onClickDownloadInvoiceFile = async (e: any) => {
    e.preventDefault();
    try {
      await requestDealerSuccessInvoiceDownload(invoiceId);
    } catch (e) {
      modal.show(e);
    }
  };

  return {
    onClickDownloadInvoiceFile,
  };
}
